import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
    textAlign: 'center',
    verticalAlign: 'middle',
  },
}));

export default function Circular() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress size={32} />
    </div>
  );
}
